/*
 * BAS PDP helpers — variant syncing + sticky CTA behavior.
 * Defers cleanly when the sections aren't on the page.
 */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const form = document.querySelector('[data-bas-pdp-form]');
    if (form && form.dataset.basPdpInitialized === 'true') return;
    if (form) form.dataset.basPdpInitialized = 'true';
    const variantInput = form && form.querySelector('[data-bas-pdp-variant-id]');
    const variantDataEl = form && form.querySelector('[data-bas-pdp-variants]');
    const optionSelects = form ? Array.from(form.querySelectorAll('[data-bas-pdp-option-index]')) : [];
    const priceEls = Array.from(document.querySelectorAll('[data-bas-pdp-price], [data-bas-pdp-sticky-price]'));
    const atcButton = form && form.querySelector('[data-bas-pdp-atc]');
    const stickySubmit = document.querySelector('[data-bas-pdp-sticky-submit]');

    function money(cents) {
      const value = Number(cents || 0) / 100;
      return value.toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    }

    let canPurchase = false;
    let isSubmitting = false;
    if (form && variantInput && variantDataEl) {
      let variants = [];
      try {
        variants = JSON.parse(variantDataEl.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      function selectedOptions() {
        return optionSelects
          .sort(function (a, b) {
            return Number(a.dataset.basPdpOptionIndex) - Number(b.dataset.basPdpOptionIndex);
          })
          .map(function (select) {
            return select.value;
          });
      }

      function findVariant() {
        if (!optionSelects.length) {
          return variants.find(function (variant) { return String(variant.id) === variantInput.value; });
        }
        const options = selectedOptions();
        return variants.find(function (variant) {
          return variant.options && variant.options.every(function (option, index) {
            return option === options[index];
          });
        });
      }

      function syncVariant() {
        const variant = findVariant();
        canPurchase = !!(variant && variant.available);

        variantInput.value = variant ? variant.id : '';
        const savings = document.querySelector('[data-bas-pdp-savings]');
        if (savings) {
          const discounted = !!(variant && variant.compare_at_price > variant.price);
          savings.hidden = !discounted;
          savings.querySelector('[data-bas-pdp-compare-price]').textContent = discounted ? money(variant.compare_at_price) : '';
          savings.querySelector('[data-bas-pdp-saving-value]').textContent = discounted ? 'Save ' + money(variant.compare_at_price - variant.price) : '';
        }
        priceEls.forEach(function (el) {
          el.textContent = variant ? money(variant.price) : 'Unavailable';
        });

        if (atcButton) {
          atcButton.disabled = isSubmitting || !canPurchase;
          atcButton.textContent = canPurchase ? (atcButton.dataset.basPdpAtcLabel || 'Add to cart') : (variant ? 'Sold out' : 'Unavailable');
        }

        if (stickySubmit) {
          stickySubmit.disabled = isSubmitting || !canPurchase;
          stickySubmit.textContent = canPurchase ? (stickySubmit.dataset.basPdpAtcLabel || 'Add to cart') : (variant ? 'Sold out' : 'Unavailable');
        }
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', syncVariant);
      });
      syncVariant();
      window.addEventListener('pageshow', function () {
        isSubmitting = false;
        syncVariant();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!canPurchase || isSubmitting) {
          event.preventDefault();
          return;
        }
        isSubmitting = true;
        if (atcButton) atcButton.disabled = true;
        if (stickySubmit) stickySubmit.disabled = true;
      });
    }

    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', function () {
        if (!canPurchase || isSubmitting) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else if (atcButton) {
          atcButton.click();
        }
      });
    }

    const bar = document.querySelector('[data-bas-pdp-sticky]');
    if (!bar) return;

    let lastShown = false;
    let ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        const shouldShow = window.scrollY > 600 && window.innerWidth < 900;
        if (shouldShow !== lastShown) {
          if (shouldShow) {
            bar.hidden = false;
            // give the browser a frame to apply hidden=false before the transform kicks in
            requestAnimationFrame(function () {
              bar.setAttribute('data-visible', 'true');
            });
          } else {
            bar.removeAttribute('data-visible');
            // hide after transition completes
            setTimeout(function () {
              if (!bar.hasAttribute('data-visible')) bar.hidden = true;
            }, 250);
          }
          lastShown = shouldShow;
        }
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  });
})();
